export default class Controller {
    time:number
    value:number

    constructor(time, value) {
        this.time = time
        this.value = value
    }
}